export const SUB_MENU_DEFAULT_KEYS = {
  id: 'name',
  label: 'title',
  value: 'name',
}

export const SUB_MENU_ITEM_PARENT_KEY = 'parent'
